<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Remakrs (Ops)</h5>
      <button
        ref="modalCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="partner-modal-section">
        <div class="partner-modal-info">
          <!-- <h5 class="info-heading">
            Total Remarks:
            <span class="item-count">{{ request.ops_remark ? '1' : '0' }}</span>
          </h5> -->
          <div class="info-content fixed-height-info">
            <div class="info-row">
              <!-- <p class="item-date">27/03/2023</p> -->
              <h5 class="item-title">
                {{ request.ops_remark }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['request']
};
</script>

<style scoped>
.partner-modal-info .info-row {
  padding: 12px 0;
}
</style>
